<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { receiptBlob } from './receipts';
const props = defineProps({
  accountId: { type: [String, Number], required: true },
  grantId: { type: [String, Number], required: true },
  item: { type: Object, required: true },
});
const emit = defineEmits(['open', 'denied']);
const target = ref(null);
const src = ref('');
const failed = ref(false);
const abort = new AbortController();
let observer;
async function load() {
  if (props.item.content_type === 'application/pdf') return;
  try {
    const blob = await receiptBlob(
      props.accountId,
      props.grantId,
      props.item.id,
      'thumb',
      abort.signal
    );
    if (!abort.signal.aborted) src.value = URL.createObjectURL(blob);
  } catch (error) {
    if (!abort.signal.aborted) {
      failed.value = true;
      if ([401, 403].includes(error.response?.status)) emit('denied');
    }
  }
}
onMounted(() => {
  if (typeof IntersectionObserver === 'undefined') return;
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) {
      observer.disconnect();
      load();
    }
  });
  observer.observe(target.value);
});
onBeforeUnmount(() => {
  abort.abort();
  observer?.disconnect();
  if (src.value) URL.revokeObjectURL(src.value);
});
</script>

<template>
  <button
    ref="target"
    type="button"
    class="w-12 h-12 shrink-0 rounded-lg border border-n-weak bg-n-alpha-2 overflow-hidden flex items-center justify-center text-xs text-n-slate-12"
    :aria-label="`Открыть чек: ${item.filename}`"
    :title="item.filename"
    @click="emit('open', item)"
  >
    <img v-if="src" :src="src" alt="" class="w-full h-full object-contain" />
    <span v-else-if="item.content_type === 'application/pdf'">PDF</span>
    <span
      v-else
      :class="failed ? 'i-lucide-image-off' : 'i-lucide-image'"
      class="text-xl"
    />
  </button>
</template>
